import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// The Back button of a form page, styled like the existing ones (City Visits,
// Add Book Distribution): returns to wherever the person came from, or — when
// the page was opened directly (a bookmark, a new tab, a reload with no
// in-app history) — to `fallback`.
export default function TspBackButton({ fallback = "/tsp" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = () => {
    if (location.key !== "default") navigate(-1);
    else navigate(fallback);
  };
  return (
    <button type="button" className="tsp-btn tsp-btn-outline-primary" onClick={goBack}>
      <ArrowLeft size={14} aria-hidden="true" /> Back
    </button>
  );
}
